import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../urunDiv.css';
import comboSicakTabagi from '../../../assets/menu/yemekler/dostluk-pekistirenler/combo-sicak-tabagi.png';
import comboBurger from '../../../assets/menu/yemekler/dostluk-pekistirenler/combo-burger.png';
import cajunBasket from '../../../assets/menu/yemekler/dostluk-pekistirenler/cajun-basket.png';
import borekBasket from '../../../assets/menu/yemekler/dostluk-pekistirenler/borek-basket.png';
import patatesTabagi from '../../../assets/menu/yemekler/dostluk-pekistirenler/patates-tabagi.png';
import atistirmalik from '../../../assets/menu/sandivic-3.png';

const DostlukPekistirenler = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768)
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const dostlukPekistirenler = [
    {
      id: 1,
      name: 'Combo Sıcak Tabağı (4 Kişilik)',
      price: '₺1499,90',
      image: comboSicakTabagi
    },
    {
      id: 2,
      name: 'Combo Burger (4 Kişilik)',
      price: '₺1749,90',
      image: comboBurger
    },
    {
      id: 4,
      name: 'Cajun Basket',
      price: '₺499,90',
      image: cajunBasket
    },
    {
      id: 5,
      name: 'Börek Basket',
      price: '₺469,90',
      image: borekBasket
    },
    {
      id: 6,
      name: 'Patates Tabağı',
      price: '₺349,90',
      image: patatesTabagi
    },
    {
      id: 8,
      name: 'Patso',
      price: '₺299,90',
      image: atistirmalik
    },
    {
      id: 9,
      name: 'Sosis Basket',
      price: '₺499,90',
      image: atistirmalik
    }
  ];

  const handleYemekClick = (yemek) => {
    if (yemek.name === 'Combo Sıcak Tabağı (4 Kişilik)') {
      navigate('/dostluk-pekistirenler/combo-sicak-tabagi');
    } else if (yemek.name === 'Combo Burger (4 Kişilik)') {
      navigate('/dostluk-pekistirenler/combo-burger');
    } else if (yemek.name === 'Cajun Basket') {
      navigate('/dostluk-pekistirenler/cajun-basket');
    } else if (yemek.name === 'Börek Basket') {
      navigate('/dostluk-pekistirenler/borek-basket');
    } else if (yemek.name === 'Patates Tabağı') {
      navigate('/dostluk-pekistirenler/patates-tabagi');
    } else if (yemek.name === 'Patso') {
      navigate('/dostluk-pekistirenler/patso');
    } else if (yemek.name === 'Sosis Basket') {
      navigate('/dostluk-pekistirenler/sosis-basket');
    }
  };

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Dostluk Pekiştirenler</h2>
        </div>
        <hr style={{color: '#D8D8D8'}} />
        <div className="urun-grid">
          {dostlukPekistirenler.map((yemek) => (
            <div 
              key={yemek.id} 
              className="urun-kart"
              onClick={() => handleYemekClick(yemek)}
              style={{ cursor: 'pointer' }}
            >
              <div className="urun-bilgi">
                <h3 className="urun-ad">{yemek.name}</h3>
                {yemek.price && <div className="urun-fiyat">{yemek.price}</div>}
              </div>
              <div className="urun-resim">
                <img src={yemek.image} alt={yemek.name} style={{
                  width: '80px',
                  height: '80px',
                  objectFit: 'cover',
                  borderRadius: '100px',
                }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Dostluk Pekiştirenler</h2>
        </div>
        <hr style={{color: '#D8D8D8'}} />
        <div className="urun-grid-computer">
          {dostlukPekistirenler.map((yemek) => (
            <div 
              key={yemek.id} 
              className="urun-kart-computer"
              onClick={() => handleYemekClick(yemek)}
              style={{ cursor: 'pointer' }}
            >
              <div className="urun-bilgi">
                <h3 className="urun-ad-computer">{yemek.name}</h3>
                {yemek.price && <div className="urun-fiyat-computer">{yemek.price}</div>}
              </div>
              <div className="urun-resim">
                <img src={yemek.image} alt={yemek.name} style={{
                  width: '100px',
                  height: '100px',
                  objectFit: 'cover',
                  borderRadius: '100px',
                }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default DostlukPekistirenler;
